import React from 'react';
import { motion } from 'framer-motion';

const Mission: React.FC = () => {
  return (
    <section className="py-16 bg-black relative">
      <motion.div 
        className="absolute inset-0 bg-gradient-to-r from-gold-950/20 to-gold-900/20"
        animate={{ 
          backgroundPosition: ['0% center', '100% center', '0% center'],
        }}
        transition={{ 
          duration: 30, 
          repeat: Infinity, 
          ease: 'linear' 
        }}
        style={{ 
          backgroundSize: '200% auto',
        }}
      />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          className="max-w-3xl mx-auto text-center"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-gold-400 mb-6">Our Mission</h2>
          <motion.p
            className="text-gray-300 text-lg"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Enterprise-grade software shouldn't be reserved for enterprises. Setora exists to give small businesses the same custom tools, automation, and AI advantages the giants have — built around how you actually work, owned by you, and priced for the real world.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};

export default Mission; 